import httpClient from "@/plugins/axios";

export const getPolls = async (page, pageSize = 10) => {
    const response = await httpClient.get(`/v1/polls/?page=${page}&page_size=${pageSize}&admin_view=1`);
    return response;;
}

export const getPoll = async (id) => {
    const response = await httpClient.get(`/v1/polls/${id}/?admin_view=1&translations=1`);
    return response;
}

export const getAnswers = async (id) => {
    const response = await httpClient.get(`/v1/polls/${id}/answers/?admin_view=1`);
    return response;
}

export const savePoll = async (poll) => {
    if (poll.id) {
        return await updatePoll(poll);
    }
    else {
        return await insertPoll(poll);
    }
};

const insertPoll = async (poll) => {
    const response = await httpClient.post('/v1/polls/?admin_view=1&html=true', poll);
    return response;
}

const updatePoll = async (poll) => {
    const response = await httpClient.put(`/v1/polls/${poll.id}/?admin_view=1&html=true`, poll);
    return response;
}

export const deletePoll = async (id) => {
    const response = await httpClient.delete(`/v1/polls/${id}/?admin_view=1`);
    return response;
}

